import React from "react";
import LegacyTransactionSearchPage from "./LegacyTransactionSearchPage";

// Natural-language search lives on the Payments - Beta tab (transactionSearchPageV2Beta).
const TransactionSearchPage = (props) => <LegacyTransactionSearchPage {...props} />;

export default TransactionSearchPage;
